<mat-expansion-panel [expanded]="expanded" hideToggle>
  <mat-expansion-panel-header
    class="panel-header"
    [ngStyle]="{ 'background-color': color + '!important' }"
  >
    <mat-panel-title>
      <div *ngIf="checkbox" style="margin-right: 10px;">
        <input type="checkbox" name="checkbox" [checked]="checked" (change)="checkedCheckbox($event)" [disabled]="disabled">
      </div>
      <app-title
        [title]="title"
        [isConditionFilled]="isValid"
        [isMandatory]="required"
      ></app-title>
    </mat-panel-title>

    <button mat-icon-button (click)="toggleExpanded()">
      <img src="assets/icons/expand_icon.svg">
    </button>
  </mat-expansion-panel-header>

  <div class="panel-content">
    <ng-content></ng-content>
  </div>
</mat-expansion-panel>
